import cookie from 'js-cookie'


const setItem = (name, value, params = {}) => cookie.set(name, value, { expires: 365, ...params })

const removeItem = cookie.remove

const setSessionItem = (...args) => cookie.set(...args)


export default {
  setItem,
  removeItem,
  setSessionItem,
}
